import { MODULE_IDS } from './constants';

/** Primary dashboard nav items — path is relative to Dashboard `/`. */
export const MODULE_NAV_ITEMS = [
  { path: 'chat', moduleId: MODULE_IDS.CHAT, label: 'Klepetalnica' },
  { path: 'qna', moduleId: MODULE_IDS.QNA, label: 'Vprašanja' },
  { path: 'polls', moduleId: MODULE_IDS.POLLS, label: 'Ankete' },
  { path: 'notices', moduleId: MODULE_IDS.NOTICES, label: 'Obvestila' },
  { path: 'gallery', moduleId: MODULE_IDS.GALLERY, label: 'Galerija' },
  { path: 'documents', moduleId: MODULE_IDS.DOCUMENTS, label: 'Dokumenti' },
  { path: 'sindikalist', moduleId: MODULE_IDS.SINDIKALIST, label: 'Sindikalist' },
  { path: 'article', moduleId: MODULE_IDS.ARTICLES, label: 'Obrazci' },
  { path: 'benefits', moduleId: MODULE_IDS.BENEFITS, label: 'Ugodnosti' },
  { path: 'contact', moduleId: MODULE_IDS.CONTACTS, label: 'Kontakti' },
];

export const MODULE_DROPDOWN_ITEMS = [
  {
    path: 'user-management',
    moduleId: MODULE_IDS.USER_MANAGEMENT,
    label: 'Upravljanje',
    requiresManageTenant: true,
  },
  { path: 'profile', moduleId: MODULE_IDS.PROFILE, label: 'Profil' },
];

export function getEnabledNavItems(config) {
  return MODULE_NAV_ITEMS.filter((item) => Boolean(config.modules?.[item.moduleId]?.enabled));
}

export function getEnabledDropdownItems(config, options = {}) {
  const { canManageTenant = false } = options;

  return MODULE_DROPDOWN_ITEMS.filter((item) => {
    if (!config.modules?.[item.moduleId]?.enabled) {
      return false;
    }

    if (item.requiresManageTenant && !canManageTenant) {
      return false;
    }

    return true;
  });
}

/** First enabled module path for post-login landing (relative segment). */
export function getDefaultModulePath(config) {
  const first = getEnabledNavItems(config)[0];
  if (first) return first.path;
  const profile = getEnabledDropdownItems(config).find((item) => item.moduleId === MODULE_IDS.PROFILE);
  return profile?.path ?? 'profile';
}
